import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imAnalyticsSubmenu', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/analytics-submenu/analytics-submenu.html'),
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/analytics-submenu/analytics-submenu.component.ts